module.exports = "h3, h4 {\n  font-weight: bolder; }\n"